import { Box, Stack, useDisclosure } from '@chakra-ui/react';
import { Button, Tooltip } from '@main/complykit';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { useUserData } from '@nhost/react';

import { CreateQuestionnaireModal } from './create-questionnaire';

export const QuestionnairesTab = ({ orgId }: { orgId: string }) => {
  const { data: organizationData } = useGetOrganizationQuery({ orgId });
  const organization = organizationData?.organizations_by_pk;

  const user = useUserData();
  const { isOpen: isCreateOpen, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();

  return (
    <Stack gap={8}>
      <Box alignSelf="end">
        <Tooltip
          content='Enable "Vendor module" for this organization'
          isDisabled={!!organization?.is_vendors_module_enabled}
        >
          <Button isDisabled={!organization?.is_vendors_module_enabled} onPress={onOpenCreate}>
            Create Questionnaire
          </Button>
        </Tooltip>
      </Box>

      <CreateQuestionnaireModal
        key="create-questionnaire-modal"
        orgId={orgId}
        email={user?.email}
        isModalOpen={isCreateOpen}
        onModalClose={onCloseCreate}
      />
    </Stack>
  );
};
